import React from 'react'
import { Checkbox } from '@mui/material'
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';

const AdditionalDetails = ({ setInputs, inputs }) => {


	const handleOnChange = (input: string, value: any) => {
		setInputs((prevState: any) => ({
			...prevState,
			[input]: value,
		}));
	};


	return (

		<div  >
			<div>

				<div className="AddJob_main_ProfileInfo">
					<div className="AddJob_main_ProfileInfo_sub">
						<div className="AddJob_main_Profile_sub">
							<Checkbox
								icon={<CheckBoxOutlineBlankIcon style={{ color: "#0275B1", border: 1 }} />}
								checkedIcon={<CheckBoxIcon style={{ color: "#0275B1", border: 1 }} />}
								sx={{
									"& .MuiSvgIcon-root": {
										fontSize: 40,
										borderRadius: 50,
									}
								}}
								checked={inputs?.additionalDetails} />

						</div>
						<div className="AddJob_main_Profile_sub2">Additional Details</div>
					</div>
					<div>
						<input type="checkbox" id="toggle-additionaldetails" className="toggle__checkbox"
							checked={inputs?.additionalDetails}
							onChange={(e) => handleOnChange("additionalDetails", e.target.checked)}
						/>
						<label htmlFor="toggle-additionaldetails" className="toggle__wrap  toggle__circle">
							<label htmlFor="toggle-additionaldetails" className="toggle__label  toggle__circle  toggle__text"></label>
						</label>
					</div>
				</div>

			</div>
		</div >
	)
}

export default AdditionalDetails